import { useEffect, useState } from 'react';
import { useForm } from '../../forms/useForm';
import { useSweetAlert } from '../../sweetAlerts/useSweetAlert';
import {getAllCharacteristic ,CreateCatalogs,DeleteCatalogs,UpdateCatalogs} from '../../../services/microsanitaria/micCharacteristic'


export const useMicCharacteristic = () => {

    const [loading, setLoading] = useState(false);
    const [createSweet, , , , , , , , , ,,, , , , ,sweetAcceptGlobal] = useSweetAlert();

    const [visible, setVisible] = useState(false);
    const [method, setMethod] = useState("");
    const [listCharacteristic, setListCharacteristic] = useState([])
    const [searchCharacteristic, setsetsearchCharacteristic] = useState([])


    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        id_characteristic: 0,
        characteristic: "",
       
    });

    const [validaciones, setValidaciones] = useState({
        characteristic: false,        
    });

    const getCharacteristic = async () => 
    {
        
        setLoading(true);
        const data = await getAllCharacteristic();
        setListCharacteristic(data);
        setsetsearchCharacteristic(data);
        setLoading(false);
    };

    useEffect(() => {
        getCharacteristic();
    }, []);

    const handleCreate = () => 
    {
        handleUpdateValues({
            characteristic: "",
        
        });    
        setMethod("create");
        setVisible(true);

    }

    const saveCreateCharacteristic = async (e) => 
    {
        e.preventDefault();

        setLoading(true);
        if (validarForm()) 
        {
            createSweet("error", "error", "Error", "Completa todos los campos obligatorios antes de guardar");
            setLoading(false);
        return;
        }

        const response = await CreateCatalogs({
            characteristic: formValues.characteristic,    
        });

        
        if (response.code === 200){
            setLoading(false);
            setVisible(false);
            createSweet("success", "success", "Se a creado correctamente");
            getCharacteristic() 
            } 
        else {
            setLoading(false);
            createSweet("warning", "warning", "No se generó correctamente la caracteristica");
        }
    };


    const saveUpdateCharacteristic = async (e) => 
    {
        e.preventDefault();
        setLoading(true);

        if (validarForm()) 
        {
           createSweet("error", "error", "Error", "Completa todos los campos obligatorios antes de guardar");
           setLoading(false);
           return;
        }

        const response = await UpdateCatalogs({
            id_characteristic: formValues.id_characteristic,
            characteristic: formValues.characteristic,   
        });

        if (response.code === 200){
                setLoading(false);
                createSweet("success", "success", "Se a actualizado correctamente");
                setVisible(false);
                getCharacteristic();

            handleUpdateValues({
                characteristic:"",
            })
        } 
    }

    const handleUpdate = (_search) => 
    {
        handleUpdateValues({
            id_characteristic: _search.id_characteristic,
            characteristic: _search.characteristic,
           
        });
        setMethod("update");
        setVisible(true);
    };


    const handleDelete = async (_find) => 
    {
        const confirmDelete = await sweetAcceptGlobal(
            "¿Eliminar Caracteristica?",
            `¿Estás seguro de eliminar el termómetro "${_find.characteristic}"?`,
            "warning",
            true
        );

        if (confirmDelete) {
            const result = await DeleteCatalogs({
                id_characteristic: _find.id_characteristic
            });

            if (result.code === 200) {
                createSweet("success", "success", "Carácteristica eliminada correctamente");
                getCharacteristic();

                setVisible(false);
            } else {                                    
                createSweet("error", "error", "Carácteristica", "No se eliminó correctamente");

            }
        } 
    };

    
    const validarForm = () => {
         let statusValidacion = false;
         let newValidaciones = {};

        if (formValues.characteristic.trim().length <= 2) {
            newValidaciones.characteristic = true;
            statusValidacion = true;
        } else {
            newValidaciones.characteristic = false;
        }

        setValidaciones(prev => ({
            ...prev,
            ...newValidaciones
        }));

        return statusValidacion;
    };

    const handleSearchThermometer = (e) => 
    {
        let busqueda = e.target.value.trim();
        let newMethod = [];
        const safeToUpper = (value) => (typeof value === "string" ? value.toUpperCase() : "");

        if (busqueda === "") {
            setListCharacteristic(searchCharacteristic); 
            return;
        }

        searchCharacteristic.forEach(element => {
            let characteristic = safeToUpper(element.characteristic);

            if ((characteristic.indexOf(busqueda.toUpperCase()) > -1) ) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });

        setListCharacteristic(newMethod);
    };


    return {
        visible, setVisible, handleInputChange, handleCreate, saveCreateCharacteristic, handleUpdate, saveUpdateCharacteristic,
        loading, setLoading, method,handleDelete, listCharacteristic, formValues, handleSearchThermometer
    };


}




